/**
 * @generated SignedSource<<5b4916f9b0f3d7c4180031f48f8c559a>>
 * @relayHash 3d52df0a60383a723d538e4ec615b7ea
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/514.0.0-2025-06-10T15:56:24.020Z/RenderCatalogEmailMutation

import { ConcreteRequest } from 'relay-runtime';
export type RenderCatalogEmailInput = {
  captchaToken?: string | null;
  clientMutationId?: string | null;
  message?: string | null;
  pageTypeId: string;
  recipientEmails: ReadonlyArray<string | null>;
  rootId: string;
  senderEmail: string;
  senderName: string;
};
export type RenderCatalogEmailMutation$variables = {
  input: RenderCatalogEmailInput;
};
export type RenderCatalogEmailMutation$data = {
  readonly renderCatalogEmail: {
    readonly clientMutationId: string | null;
  } | null;
};
export type RenderCatalogEmailMutation = {
  response: RenderCatalogEmailMutation$data;
  variables: RenderCatalogEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenderCatalogEmailPayload",
    "kind": "LinkedField",
    "name": "renderCatalogEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenderCatalogEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenderCatalogEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-trade/514.0.0-2025-06-10T15:56:24.020Z/RenderCatalogEmailMutation",
    "metadata": {},
    "name": "RenderCatalogEmailMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "79ebeba0fdb4ccd5ea495b5341d04f9c";

export default node;
